module.exports = __webpack_public_path__ + "static/media/3.1d245368.jpeg";